<div class="row drawer-content drawer-direct-content">
    <div class="col">
        <ng-container *ngIf="releases && releases.length">
            <div id="release-notes-list">
                <div class="drawer-content-fixed-header">
                    <h4 class="d-flex align-items-center mb-0" [ngClass]="{'pt-3': (externals.length || availableTypes.length) && showFilters, 'py-3': (!externals.length && !availableTypes.length) || !showFilters}">
                        <span>{{"Release notes" | translate}} <small class="hidden">{{ today | date: 'dd-MM-yyyy HH:mm'}}</small></span>
                        <i *ngIf="(externals.length || availableTypes.length)" tooltip="{{(showFilters ? 'Hide filters' : 'Show filters') | translate}}" placement="right"
					class="far fa-bars-filter btn btn-md btn-icon ml-2 {{showFilters ? 'btn-primary-light text-white' : ''}}" (click)="showFilters = !showFilters"></i>
                        <span class="hidden service-name">{{service?.name}}</span>
                        <a class="btn btn-link mr-2 ml-auto" (click)="toggleAll();">
                            <u>{{(expended ? "Close all" : "Expend all") | translate}}</u>
                        </a>
                        <i class="fas fa-print btn-xs btn-bordered btn-icon item-remove simple-icon"
                            tooltip="{{'Print release notes' | translate}}"
                            placement="left"
                            container="body" (click)="printRN();"></i>
                    </h4>
                    <div *ngIf="(externals.length || availableTypes.length) && showFilters" class="d-flex align-content-center align-items-center bg-light p-2 rounded-lg mb-4">
                        <span *ngIf="externals.length" [ngClass]="{'disabled': !liveFilter}" (click)="liveFilter = !liveFilter" class="badge toggler badge-live mr-2">{{"locally" | translate}}</span>
                        <ng-container *ngFor="let ext of externals">
                            <span (click)="ext.status = !ext.status" class="badge toggler badge-primary-light mr-2" [ngClass]="{'disabled': !ext.status}">{{ext.type}}</span>
                        </ng-container>
                        <ng-container *ngFor="let type of availableTypes; let first = first;">
                            <span (click)="type.status = !type.status" class="badge toggler badge-release-note-type badge-sm badge-{{type.type}}" [ngClass]="{'ml-auto': first, 'ml-2': !first, 'active': type.status}">{{type.type}}</span>
                        </ng-container>
                    </div>
                </div>
                <div [ngClass]="{'hidden': filtered(rc)}" class="card-new mb-3" *ngFor="let rc of releases">
                    <div class="header d-flex align-items-center mb-3" (click)="toggleRc(rc);"
                        [ngClass]="{'toggler': rc.description && rc.description != '-'}">
                        <span class="badge badge-outline-dark mr-2">{{rc.version || 'vX'}}</span>
                        <span class="title">{{rc.title}}</span>
                        <span *ngIf="rc.destination" class="badge badge-primary-light mt-0 ml-2">{{rc.destination}}</span>
                        <release-note-types-handler class="ml-auto mr-2 d-inline-flex" [readyOnly]="true" [size]="'sm'" [selectedTypes]="rc.typesOfPublication" ></release-note-types-handler>
                        <i  *ngIf="rc.description && rc.description != '-'" class="far" [ngClass]="{'fa-angle-down': !rc.open, 'fa-angle-up': rc.open}"></i>
                    </div>
                    <div *ngIf="rc.description && rc.description != '-'" class="body mb-3" [ngClass]="{'hidden': !rc.open}" [innerHTML]="rc.description">
                    </div>
                    <div class="footer d-flex align-items-center pt-3">
                        <i class="fad fa-circle-user"></i>
                        <span>{{"published by" | translate}}</span>
                        <b>{{rc.username}}</b>
                        <span>{{"on" | translate}}</span>
                        <b>{{rc.date | date: 'dd-MM-yyyy H:mm:ss'}}</b>
                    </div>
                </div>
            </div>
        </ng-container>
        <ng-container *ngIf="!releases || releases.length < 1">
            <div class="alert alert-info mt-3">
                {{"No release notes for the service yet!" | translate}}
            </div>
        </ng-container>
    </div>
</div>